import React, { useState, useEffect } from "react";
import { HashLink } from "react-router-hash-link";
import { ReactComponent as Arrow } from "../../../assets/images/landing/arrow.svg";
import defaultPrices from "./defaultPrices.json";

const Prices = () => {
  const [prices, setPrices] = useState(defaultPrices.prices ?? []);

  const fetchPrices = async () => {
    const response = await fetch("prices.json");

    if (response.ok) {
      const json = await response.json();
      if (json?.prices) {
        console.log("Обновляем цены", json.prices);
        setPrices(json.prices);
      }
    } else {
      console.log('Не удалось обновить цены', response);
    }
  }

  useEffect(() => {
    fetchPrices();
  }, []);

  const pricesList = prices.map((price, i) => (
    <div className="price-tr" key={i}>
      <div className="price-td">{i + 1}</div>
      <div className="price-td">{price[0].toLocaleString()} ₽</div>
      <div className="price-td">{price[1].toLocaleString()} ₽</div>
    </div>
  ));

  return (
    <section className="container-area-field prices-color" id="prices">
      <div className="container-main-area big-container">
        <div className="application-area advantages-area prices-color">
          <div className="title-home title-block title-block--wide top-line">
            <h2 className="title">Цены на электронную систему</h2>
          </div>

          <div className="price-table">
            <div className="price-tr">
              <div className="price-th">Кол-во колоколов</div>
              <div className="price-th">Базовый комплект</div>
              <div className="price-th">Монтаж (+материалы)</div>
            </div>

            {pricesList}

            {/* <div className="price-tr">
              <div className="price-td">1</div>
              <div className="price-td">135 500 ₽</div>
              <div className="price-td">42 000 ₽</div>
            </div> */}
          </div>

          <div
            className="order-system-area order-system-area--mobile"
            style={{ justifyContent: "center" }}
          >
            <HashLink to="/#contact" smooth="true" className="btn btn-yellow">
              Купить систему
              <Arrow />
            </HashLink>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Prices;
